export default __webpack_public_path__ + "assets/models/dc3b605f896c1d4d012047efd356b087.gltf";